// import React, { useEffect, useMemo, useRef } from 'react';
// import * as echarts from 'echarts';
// import { useTranslation } from 'react-i18next';

// export type DataItem = {
//     name: string;
//     value: string | number;
//     color?: string;
// };

// export type RosePieChartProps = {
//     data?: DataItem[];
//     title?: string;
//     height?: number | string;
//     className?: string;
// };

// /**
//  * 将可能带千位分隔符的字符串或数字转为 Number（失败则返回 0）
//  */
// function parseNumber(v: string | number): number {
//     if (typeof v === 'number') return v;
//     try {
//         const cleaned = String(v).replace(/[,，\s]/g, '');
//         const n = Number(cleaned);
//         return Number.isFinite(n) ? n : 0;
//     } catch {
//         return 0;
//     }
// }


// export const RosePieChart: React.FC<RosePieChartProps> = () => {
//     const elRef = useRef<HTMLDivElement | null>(null);
//     const chartRef = useRef<echarts.ECharts | null>(null);
//     const { t } = useTranslation()
//     const data: DataItem[] = useMemo(() => {
//         return [
//             { name: t('home.gateExchange1'), value: '30,000,000', color: '#10B981', num: '30,000,000' },
//             { name: t('home.liquidityT1'), value: '28,000,000', color: '#3B82F6', num: 20000000 },
//             { name: t('home.liquidityT2'), value: '30,000,000', color: '#FB923C', num: 20000000 },
//             { name: t('home.privateEquity'), value: '30,000,000', color: '#FBBF24', num: 30000000 }
//         ];
//     }, [t])
//     // 初始化与销毁（只在 mount/unmount）
//     useEffect(() => {
//         if (!elRef.current) return;
//         if (!chartRef.current) {
//             chartRef.current = echarts.init(elRef.current);
//         }
//         const chart = chartRef.current;

//         const handleResize = () => chart.resize();
//         window.addEventListener('resize', handleResize);

//         return () => {
//             window.removeEventListener('resize', handleResize);
//             chart && chart.dispose();
//             chartRef.current = null;
//         };
//     }, []);

//     // 当 data/title 变化时更新 option
//     useEffect(() => {
//         const chart = chartRef.current;
//         if (!chart) return;

//         const parsed = data.map(d => ({
//             name: d.name,
//             value: parseNumber(d.value),
//             itemStyle: { color: d.color || undefined }
//         }));

//         const option: echarts.EChartsOption = {

//             tooltip: {
//                 trigger: 'item',
//                 formatter: (params: any) => {
//                     const value = (params.num ?? 0).toLocaleString();
//                     const pct = (params.percent ?? 0).toFixed(2);
//                     return `${params.marker} ${params.name}<br/> ${value} (${pct}%)`;
//                 }
//             },
//             series: [
//                 {
//                     name: '',
//                     type: 'pie',
//                     radius: '55%',
//                     center: ['50%', '55%'],
//                     data: parsed.sort((a, b) => (a.value as number) - (b.value as number)),
//                     roseType: 'radius',
//                     label: {
//                         color: 'rgba(255, 255, 255, 0.85)',
//                         formatter: '{b}\n{c}',
//                         fontSize: 12,
//                         lineHeight: 16
//                     },
//                     labelLine: {
//                         lineStyle: { color: 'rgba(255,255,255,0.35)' },
//                         smooth: 0.2,
//                         length: 10,
//                         length2: 8,
//                     },
//                     itemStyle: {
//                         shadowBlur: 200,
//                         shadowColor: 'rgba(0, 0, 0, 0.5)'
//                     },
//                     animationType: 'scale',
//                     animationEasing: 'elasticOut',
//                     animationDelay: (_idx: number) => Math.random() * 200
//                 }
//             ]
//         };

//         chart.setOption(option, { notMerge: true });
//     }, [data]);



//     return (
//         <div ref={elRef} className='w-full h-[300px]' />

//     );
// };

// export default RosePieChart;

import React, { useEffect, useMemo, useRef } from 'react';
import * as echarts from 'echarts';
import { useTranslation } from 'react-i18next';

export type DataItem = {
    name: string;
    value: string | number;
    color?: string;
};

export type RosePieChartProps = {
    data?: DataItem[];
    title?: string;
    height?: number | string;
    className?: string;
};

function parseNumber(v: string | number): number {
    if (typeof v === 'number') return v;
    try {
        const cleaned = String(v).replace(/[,，\s]/g, '');
        const n = Number(cleaned);
        return Number.isFinite(n) ? n : 0;
    } catch {
        return 0;
    }
}

export const RosePieChart: React.FC<RosePieChartProps> = () => {
    const elRef = useRef<HTMLDivElement | null>(null);
    const chartRef = useRef<echarts.ECharts | null>(null);
    const { t } = useTranslation();

    // 是否对 value 做 sqrt 映射（当你希望扇形“面积”与原始 value 成正比时设为 true）
    const useSqrtScale = true;

    const data: DataItem[] = useMemo(() => {
        return [
            { name: t('home.gateExchange1'), value: '30,000,000', color: '#10B981' },
            { name: t('home.liquidityT1'), value: '20,000,000', color: '#3B82F6' },
            { name: t('home.liquidityT2'), value: '20,000,000', color: '#EE1D26' },
            { name: t('home.privateEquity'), value: '30,000,000', color: '#FBBF24' }
        ];
    }, [t]);

    useEffect(() => {
        if (!elRef.current) return;
        if (!chartRef.current) {
            chartRef.current = echarts.init(elRef.current);
        }
        const chart = chartRef.current;

        const handleResize = () => chart.resize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            chart && chart.dispose();
            chartRef.current = null;
        };
    }, []);

    useEffect(() => {
        const chart = chartRef.current;
        if (!chart) return;

        // 先把原始数值解析出来
        const withOriginal = data.map(d => {
            const raw = parseNumber(d.value);
            return { name: d.name, rawValue: raw, color: d.color };
        });

        // 映射策略：如果 useSqrtScale 为 true，则用 sqrt(raw) 作为发送给 echarts 的 value
        const parsed = withOriginal.map(d => {
            const mapped = useSqrtScale ? Math.sqrt(d.rawValue) : d.rawValue;
            return {
                name: d.name,
                // 传给图表的 value（用于半径或角度分配）
                value: mapped,
                // 保留原始值用于 tooltip/label 显示
                originalValue: d.rawValue,
                itemStyle: { color: d.color || undefined }
            };
        });

        const option: echarts.EChartsOption = {
            tooltip: {
                trigger: 'item',
                formatter: (params: any) => {
                    // params.data.originalValue 存着真实值
                    const orig = params.data?.originalValue ?? params.value;
                    const value = (orig ?? 0).toLocaleString();
                    return `${params.marker} ${params.name}<br/> ${value}`;
                }
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    // 全局半径范围（内圈，外圈）百分比或像素
                    radius: ['30%', '70%'],
                    // 玫瑰图：'radius' -> 半径由 value 决定；不写则按角度分配
                    roseType: 'radius',
                    center: ['50%', '55%'],
                    // 确保小值有最小角度以便交互可见（根据需要调整）
                    minAngle: 8,
                    // 数据：注意使用 mapped value，但保留 originalValue 用于展示
                    data: parsed.sort((a, b) => (a.value as number) - (b.value as number)),
                    label: {
                        color: 'rgba(255, 255, 255, 0.85)',
                        // 显示原始值而非映射后的 value
                        formatter: (params: any) => {
                            const name = params.name;
                            const orig = params.data?.originalValue ?? params.value;
                            return `${name}\n${(orig ?? 0).toLocaleString()}`;
                        },
                        fontSize: 12,
                        lineHeight: 16
                    },
                    labelLine: {
                        lineStyle: { color: 'rgba(255,255,255,0.35)' },
                        smooth: 0.2,
                        length: 10,
                        length2: 8,
                    },
                    itemStyle: {
                        shadowBlur: 200,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: (_idx: number) => Math.random() * 200
                }
            ]
        };

        chart.setOption(option, { notMerge: true });

    }, [data, useSqrtScale]);

    return (
        <div ref={elRef} className='w-full h-[300px]' />
    );
};

export default RosePieChart;